import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, combineLatest, map } from 'rxjs';
import { SiteLanguage } from '../../../dto/response/site.settings';
import { LanguageService } from '../../../service/language.service';

interface LanguageSelectorViewModel {
  languages: SiteLanguage[];
  current?: SiteLanguage;
  /** Solo tiene sentido mostrar el selector cuando el site soporta más de un idioma. */
  visible: boolean;
}

/**
 * Selector de idioma de contenido del header. Oculto si el site solo tiene un idioma
 * soportado (retrocompat: sites sin `language` configurado en settings/v2).
 */
@Component({
  selector: 'app-language',
  standalone: true,
  imports: [AsyncPipe, NgbDropdownModule, TranslateModule],
  templateUrl: './language.component.html',
  styleUrl: './language.component.scss',
})
export class LanguageComponent {
  readonly vm$: Observable<LanguageSelectorViewModel> = combineLatest([
    this.languageService.availableLanguages$,
    this.languageService.currentLanguage$,
  ]).pipe(
    map(([languages, currentIso]) => ({
      languages,
      current: languages.find((l) => l.isoCode === currentIso),
      visible: languages.length > 1,
    })),
  );

  constructor(private languageService: LanguageService) {}

  select(isoCode: string): void {
    this.languageService.switchLanguage(isoCode);
  }
}
